export default __webpack_public_path__ + "static/media/rebate_coin_04.51a5fdcb.png";